import React from 'react';
import { Star, ThumbsUp, User } from 'lucide-react';

const ReviewCard = ({ review, onVoteHelpful, showVoteButton = true }) => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        className={`w-4 h-4 ${
          index < rating
            ? 'text-yellow-400 fill-current'
            : 'text-gray-300'
        }`}
      />
    ));
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const handleVoteHelpful = () => {
    if (onVoteHelpful) {
      onVoteHelpful(review._id);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-4 border border-gray-200">
      {/* Header with user info and rating */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center">
            <User className="w-6 h-6 text-white" />
          </div>
          <div>
            <h4 className="font-semibold text-gray-900">
              {review.utilisateur?.nom} {review.utilisateur?.prenom}
            </h4>
            <p className="text-sm text-gray-500">
              {formatDate(review.createdAt)}
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-1">
          {renderStars(review.note)}
          <span className="ml-2 text-sm font-medium text-gray-700">
            {review.note}/5
          </span>
        </div>
      </div>

      {/* Review title */}
      <h3 className="font-semibold text-lg text-gray-900 mb-2">
        {review.titre}
      </h3>

      {/* Review content */}
      <p className="text-gray-700 mb-4 leading-relaxed">
        {review.commentaire}
      </p>

      {/* Verified purchase badge */}
      {review.achat_verifie && (
        <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 mb-4">
          ✓ Achat vérifié
        </div>
      )}

      {/* Admin response */}
      {review.reponse_admin && (
        <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-4">
          <div className="flex">
            <div className="ml-3">
              <p className="text-sm font-medium text-blue-800">
                Réponse de l'équipe
              </p>
              <p className="text-sm text-blue-700 mt-1">
                {review.reponse_admin}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Footer with helpful votes */}
      <div className="flex items-center justify-between pt-4 border-t border-gray-200">
        <div className="flex items-center space-x-4">
          {showVoteButton && (
            <button
              onClick={handleVoteHelpful}
              className="flex items-center space-x-2 text-sm text-gray-600 hover:text-blue-600 transition-colors"
            >
              <ThumbsUp className="w-4 h-4" />
              <span>Utile</span>
            </button>
          )}
          {review.votes_utiles > 0 && (
            <span className="text-sm text-gray-500">
              {review.votes_utiles} personne{review.votes_utiles > 1 ? 's' : ''} 
              {review.votes_utiles > 1 ? 'trouvent' : 'trouve'} cet avis utile
            </span>
          )}
        </div>
        
        {/* Review status indicator (for admin) */}
        {review.statut && review.statut !== 'approuve' && (
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
            review.statut === 'en_attente' 
              ? 'bg-yellow-100 text-yellow-800'
              : 'bg-red-100 text-red-800'
          }`}>
            {review.statut === 'en_attente' ? 'En attente' : 'Rejeté'}
          </span>
        )}
      </div>
    </div>
  );
};

export default ReviewCard;